import React, { useState, useEffect } from "react";
import {
  Container,
  Button,
  Grid,
  IconButton,
  Menu,
  MenuItem,
} from "@material-ui/core";
import { Card, CardHeader } from "reactstrap";
import { DataGrid } from "@material-ui/data-grid";
import { Check, Close, Edit } from "@material-ui/icons";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
import Swal from "sweetalert2";

import SearchInput from "../../components/basic/SearchInput";
import { getVideosForDisplay } from "../../repositories/videoRepository";
import DialogVideo from "./DialogVideo";
import { deleteVideo } from "../../repositories/videoRepository";
import filterTable from "../../utils/filterTable";
import ModalLoading from "../../components/modalLoading/ModalLoading";
import { notify } from "../../utils/notify";

const PreviewVideo = () => {
  const [loading, setLoading] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [allVideos, setAllVideos] = useState([]);
  const [filteredVideos, setFilteredVideos] = useState([]);
  const [open, setOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const [refreshList, setRefreshList] = useState(false);

  const renderActiveIcon = (params) => {
    return params.value ? (
      <Check style={{ color: "green" }} />
    ) : (
      <Close style={{ color: "red" }} />
    );
  };

  const renderEditButton = (data) => {
    return (
      <>
        <PopupState variant="popover" popupId={`action-menu-${data.row.Id}`}>
          {(popupState) => (
            <React.Fragment>
              <IconButton variant="contained" {...bindTrigger(popupState)}>
                <Edit style={{ color: "blue" }} />
              </IconButton>
              <Menu {...bindMenu(popupState)}>
                <MenuItem
                  onClick={() => {
                    handleOpen(data.row);
                    popupState.close();
                  }}
                >
                  Editar
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handleDeleteVideo(data.row.Id);
                    popupState.close();
                  }}
                >
                  Excluir
                </MenuItem>
              </Menu>
            </React.Fragment>
          )}
        </PopupState>
      </>
    );
  };

  const columns = [
    {
      field: "Id",
      headerName: "Id",
      editable: false,
      flex: 0.25,
    },
    {
      field: "Titulo",
      headerName: "Título",
      editable: false,
      flex: 1,
    },
    {
      field: "LocalizacaoPontoAcesso",
      headerName: "Localização",
      editable: false,
      flex: 1.5,
    },
    {
      field: "Produto",
      headerName: "Produto",
      editable: false,
      flex: 0.5,
    },
    {
      field: "Ativo",
      headerName: "Ativo",
      align: "center",
      editable: false,
      renderCell: renderActiveIcon,
      flex: 0.3,
    },
    {
      field: "Acoes",
      headerName: "Ações",
      align: "center",
      editable: false,
      sortable: false,
      renderCell: renderEditButton,
      flex: 0.3,
    },
  ];

  // Busca lista de videos cadastrados
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const { data: response } = await getVideosForDisplay();
        if (response.data) {
          response.data.map((row) => (row.id = row.Id));

          setAllVideos(response.data);
          setFilteredVideos(response.data);
        }
        setLoading(false);
      } catch (error) {
        console.error("ERROR: PreviewVideo", error);
        setLoading(false);
      }
    };

    fetchData();
  }, [refreshList]);

  // filtro da lista de vídeos
  const handleChangeFilter = (e) => {
    if (!e) return setFilteredVideos(allVideos);

    const newArr = filterTable({
      data: allVideos,
      text: e.target.value,
      columns: ["Titulo", "LocalizacaoPontoAcesso", "Produto"],
    });

    setFilteredVideos(newArr);
  };

  const handleOpen = (videoData) => {
    setEditData(videoData);
    setOpen(true);
  };

  const handleClose = (refresh = false) => {
    if (refresh) {
      setRefreshList(!refreshList);
    }
    setOpen(false);
    setEditData(null);
  };

  const handleDeleteVideo = (id) => {
    Swal.fire({
      icon: "question",
      text: "Tem certeza que deseja excluir este Vídeo?",
      showConfirmButton: true,
      showCancelButton: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setLoadingDelete(true);
          const result = await deleteVideo({ id });
          if (result.data && result.data.success) {
            notify("Video Excluído com sucesso.", true, "info");
            setRefreshList(!refreshList);
            return;
          }

          notify("Não foi possível excluir o Video.");
        } catch (error) {
          notify("Não foi possível excluir o Video.");
          console.error("error IndermediadorList delete item", error);
        } finally {
          setLoadingDelete(false);
        }
      }
    });
  };

  return (
    <>
      {loadingDelete && <ModalLoading loading={loadingDelete} />}
      <Container>
        <Card className="card-default">
          <CardHeader>
            <Grid container alignItems="center" spacing={1}>
              <Grid item lg={4} md={6} sm={12} xs={12}>
                <label className="title">Vídeos</label>
              </Grid>

              <Grid item lg={6} md={6} sm={12} xs={12}>
                <SearchInput
                  placeholder="Pesquisar"
                  handleChange={handleChangeFilter}
                />
              </Grid>

              <Grid
                container
                justify="flex-end"
                alignItems="center"
                item
                lg={2}
                md={12}
                sm={12}
                xs={12}
              >
                <Grid item>
                  <Button
                    variant="contained"
                    size="large"
                    id="buttonInserir"
                    onClick={() => handleOpen(null)}
                  >
                    <img
                      src="img/inserir.svg"
                      className="iconInserir"
                      alt="Inserir"
                    />
                    INSERIR
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </CardHeader>
          <DataGrid
            loading={loading}
            columns={columns}
            rows={filteredVideos}
            rowsPerPageOptions={[5, 10, 25, 50]}
            pageSize={5}
            autoHeight
            disableSelectionOnClick
            disableColumnMenu
          />
        </Card>
      </Container>

      {open && (
        <DialogVideo
          open={open}
          editData={editData}
          handleClose={handleClose}
        />
      )}
    </>
  );
};

export default PreviewVideo;
